import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=0808a1c2&scoped=true&"
import script from "./workbench.vue?vue&type=script&lang=js&"
export * from "./workbench.vue?vue&type=script&lang=js&"
import style0 from "./workbench.vue?vue&type=style&index=0&id=0808a1c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808a1c2",
  null
  
)

export default component.exports